export default __webpack_public_path__ + "static/media/about-us.59f5ae75.jpg";